import { Cookies } from '@hh.ru/browser-api-utils';

export enum ExperimentGroup {
    CONTROL = 'control',
    EXPERIMENT = 'experiment',
}
const EXPERIMENT_PARAM_PREFIX = 'experiment_';
const SANITIZE_RE = /[^a-z0-9_-]/gi;
const COOKIE_EXPIRY_HOURS = 365 * 24; // 365 дней в часах

const sanitize = (value?: string | null): string => {
    if (!value) return '';
    return value.replace(SANITIZE_RE, '');
};

const parseQueryParams = (): Record<string, string> => {
    const params = new URLSearchParams(window.location.search);
    const result: Record<string, string> = {};
    params.forEach((value, key) => {
        result[key] = value;
    });
    return result;
};

const getAllExperimentCookies = (): Record<string, string> => {
    const allCookies = Cookies.getAll();
    const experimentCookies: Record<string, string> = {};

    allCookies.forEach((cookie) => {
        if (cookie.name && cookie.name.startsWith(EXPERIMENT_PARAM_PREFIX)) {
            experimentCookies[cookie.name] = cookie.value || '';
        }
    });

    return experimentCookies;
};

// утилита для тестирования экспериментов
export const setExperimentCookieByArgument = (): void => {
    const params = new URLSearchParams(window.location.search);

    const toEnable = params.getAll('enable_experiment').map(sanitize);
    const toDisable = params.getAll('disable_experiment').map(sanitize);

    for (const exp of toEnable) {
        Cookies.set(`${EXPERIMENT_PARAM_PREFIX}${exp}`, ExperimentGroup.EXPERIMENT, COOKIE_EXPIRY_HOURS);
    }

    for (const exp of toDisable) {
        Cookies.set(`${EXPERIMENT_PARAM_PREFIX}${exp}`, ExperimentGroup.CONTROL, COOKIE_EXPIRY_HOURS);
    }
};

export const getExperiments = (
    controlExperiments: string[] = [],
    enabledExperiments: string[] = []
): Record<string, ExperimentGroup> => {
    // Начальное состояние приходит из session
    const experiments: Record<string, ExperimentGroup> = {};
    controlExperiments.forEach((exp) => {
        experiments[exp] = ExperimentGroup.CONTROL;
    });
    enabledExperiments.forEach((exp) => {
        experiments[exp] = ExperimentGroup.EXPERIMENT;
    });

    // Для тестирования через cookie и query
    const cookies = getAllExperimentCookies();
    const query = parseQueryParams();

    const entries = [cookies, query].flatMap((source) => Object.entries(source));

    for (const [rawName, rawValue] of entries) {
        if (rawName.startsWith(EXPERIMENT_PARAM_PREFIX)) {
            const name = sanitize(rawName.replace(EXPERIMENT_PARAM_PREFIX, ''));
            if (name) {
                const value = sanitize(rawValue);

                if (value === ExperimentGroup.CONTROL) {
                    experiments[name] = ExperimentGroup.CONTROL;
                } else if (value === ExperimentGroup.EXPERIMENT) {
                    experiments[name] = ExperimentGroup.EXPERIMENT;
                }
            }
        }
    }

    return experiments;
};
